import React, { useEffect, useRef } from "react";
import "./salonprofilemodal.css";
import leftArrow from "../../../../Assets/images/icons/long_left.svg";
import share_svg from "../../../../Assets/images/icons/share_icon_n.svg";
import moment from "moment";

const CustomerExp = ({
  category,
  closeModal,
  salonData,
  workData,
  tempSelectedCategory,
  tempSelectedImage,
}) => {
  const videoRefs = useRef([]);

  function categorizeData(data, activeCategoryId) {
    const categorizedData = {};

    data.forEach((item) => {
      const categoryName = item.category_data.name;
      const categoryGender = item.category_data.category_gender;
      const objId = item.id;
      const categoryId = item.category_data.id;
      const uniqueKey = `${categoryName}_${categoryGender}_${categoryId}_${objId}`;

      if (!categorizedData[uniqueKey]) {
        categorizedData[uniqueKey] = [];
      }
      categorizedData[uniqueKey].push(item);
    });

    let result = Object.entries(categorizedData).map(([uniqueKey, catData]) => {
      const [catName, catGender, catId, objId] = uniqueKey.split("_");
      return {
        cat_name: catName,
        cat_gender: catGender,
        cat_id: catId,
        cat_data: catData,
        id: objId,
      };
    });

    result.sort((a, b) => {
      const isActiveA = a.id == tempSelectedImage;
      const isActiveB = b.id == tempSelectedImage;

      if (isActiveA === isActiveB) return 0;
      if (isActiveA) return -1;
      if (isActiveB) return 1;
    });

    if (activeCategoryId === "all") {
      return result.sort((a, b) => {
        const isActiveA = parseInt(a.cat_id) === tempSelectedCategory;
        const isActiveB = parseInt(b.cat_id) === tempSelectedCategory;

        if (isActiveA === isActiveB) return 0;
        if (isActiveA) return -1;
        if (isActiveB) return 1;
      });
    }

    return result.sort((a, b) => {
      const isActiveA = parseInt(a.cat_id) === activeCategoryId;
      const isActiveB = parseInt(b.cat_id) === activeCategoryId;

      if (isActiveA === isActiveB) return 0;
      if (isActiveA) return -1;
      if (isActiveB) return 1;
    });
  }

  const handleVideoRef = (el, idx) => {
    if (el && !videoRefs.current.includes(el)) {
      videoRefs.current[idx] = el; // Store each video at its unique index
      console.log(`Added video ${idx} to refs:`, el);
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        console.log(
          "Observed entries:",
          entries.map((e) => e.target)
        );

        let mostVisibleVideo = null;
        let maxVisibility = 0;

        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            console.log("Intersecting video:", entry.target);
            const visibility = entry.intersectionRatio;
            if (visibility > maxVisibility) {
              maxVisibility = visibility;
              mostVisibleVideo = entry.target;
            }
          }
        });

        videoRefs.current.forEach((video) => {
          if (video && video !== mostVisibleVideo) {
            video.pause();
          }
        });

        if (mostVisibleVideo) {
          mostVisibleVideo.play().catch((error) => {
            console.error("Error playing video:", error);
          });
        }
      },
      { threshold: 0.5 } // Increased threshold for better detection
    );

    setTimeout(() => {
      videoRefs.current.forEach((video, index) => {
        if (video) {
          observer.observe(video);
          console.log(`Observing video ${index}:`, video);
        }
      });
    }, 500);

    return () => {
      videoRefs.current.forEach((video) => {
        if (video) observer.unobserve(video);
      });
    };
  }, [workData]); // Runs when `workData` updates

  const handleShare = () => {
    if (!navigator.share) {
      document.execCommand("copy", true, window.location.href);
      alert("Link copied to clipboard");
      return;
    }

    navigator
      .share({
        title: salonData?.name || "Trakky",
        text: "Check out this salon",
        url: window.location.href,
      })
      .catch((error) => console.log("Error sharing", error));
  };

  const formatTime = (dateTime) => {
    const now = moment();
    const createdAt = moment(dateTime);
    const duration = moment.duration(now.diff(createdAt));
    const hours = duration.asHours();

    return hours < 24
      ? `${Math.floor(hours)} hours ago`
      : createdAt.format("MMM DD, YYYY");
  };

  let categoryData = categorizeData(workData, category?.id);

  return (
    <div className="CE-main-container">
      <div className="CE-modal-header">
        <img
          src={leftArrow}
          alt="Back"
          onClick={closeModal}
          className="!cursor-pointer"
        />
        <h2>Customer's experience</h2>
      </div>
      {categoryData?.map((item, index) => (
        <div key={index}>
          <div className="CE-modal-category-title">
            <h3>
              {item?.cat_name} ({item?.cat_gender})
            </h3>
            <span></span>
          </div>
          <div className="CE-customer-exp-item-outer">
            {item?.cat_data?.map((entry, idx) => (
              <div className="CE-customer-exp-item" key={idx}>
                <div className="CE-c-i-salon-info">
                  <img src={salonData?.main_image} alt="Salon" />
                  <h4>{salonData?.name}</h4>
                </div>
                <div className="CE-customer-exp-item-img object-contain !bg-white">
                  {entry?.video ? (
                    <video
                      ref={(el) => handleVideoRef(el, index * 20 + idx)} // 🔹 Fixed ref assignment
                      className="video-player"
                      controls
                      key={index} // 🔹 Fixed key assignment
                      poster={
                        entry?.video_thumbnail_image || entry?.client_image
                      }
                      loop
                    >
                      <source src={entry?.video} type="video/mp4" />
                    </video>
                  ) : (
                    <img
                      src={entry?.client_image}
                      alt="Client"
                      className="object-contain"
                    />
                  )}
                </div>
                <div className="CE-customer-exp-item-details">
                  <div className="CE-c-e-name-share-img">
                    <div className="CE-item-share-like">
                      <button onClick={handleShare}>
                        <img src={share_svg} alt="Share" />
                      </button>
                    </div>
                    <div className="CE-item-service-name">{entry?.service}</div>
                  </div>
                  <div className="CE-item-item-desc">{entry?.description}</div>
                  <div className="CE-item-item-time pt-1">
                    {formatTime(entry?.created_at)}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default CustomerExp;
